export const kelasLiveEvents = {
  bimbelTabViewed: "bimbel tab viewed",
  liveClassJoined: "live class joined",
  liveClassJoinButtonPressed: "live class join button pressed",
  liveClassJoinError: "live class join error",
  liveClassTrialStarted: "live class trial started",
  liveClassSectionViewed: "live class section viewed",
  sectionScrolled: "section scrolled",
  liveClassLoadingModalViewed: "live class loading modal viewed",
  onGoingClassDetailModalViewed: "ongoing class detail modal viewed",
  upcomingClassDetailModalViewed: "upcoming class detail modal viewed",
  upcomingClassDetailClicked: "upcoming class detail clicked",
  ongoingClassDetailClicked: "ongoing class detail clicked",
  classReportClicked: "class report clicked",
  pastClassDetailModalViewed: "past class detail modal viewed",
  downloadClassMaterialPressed: "download class material pressed",
  viewReviewVideo: "view review video",
  callMeKakClicked: "call me kak clicked",
  contactKakakSiagaClicked: "contact kakak siaga clicked",
  contactKakakSiagaBottomSheetViewed: "contact kakak siaga bottom sheet viewed",
  iWannaCallClicked: "i wanna call clicked",
  kakakSiagaCallSuccessViewed:
    "kakak siaga will call you soon success screen viewed",
  callMeDiffNumberClicked:
    "call me on different number clicked on contact kakak siaga success screen",
  okayKakSuccessScreenClicked:
    "okay kak clicked on contact kakak siaga success screen",
  writeNumHereBottomSheetViewed: "write your number here bottom sheet viewed",
  sendNumBottomSheetClicked: "send clicked on write your number bottom sheet",
  numBottomSheetDroppedOff: "dropped off write your number bottom sheet",
  contactKakakSiagaBottomSheetDroppedOff:
    "dropped off contact kakak siaga bottom sheet",
  liveClassSeeAllClicked: "live class see all clicked",
  qnaIconClicked: "q&a icon clicked",
  welcomeScreenForBecomingPaidUserViewed:
    "welcome screen for becoming paid user viewed",
  primaryCTAClickedFromWelcomeScreen: "primary cta clicked from welcome screen",
  classYetToStartBottomSheetViewed: "class is yet to start bottom sheet viewed"
};

export enum LiveClassSections {
  ONGOING_CLASS = "ongoing class",
  UPCOMING_CLASS = "upcoming class",
  PAST_CLASS = "past class",
  USER_FEEDBACK = "user feedback",
  PRACTICE = "practice",
  EXAM_PRACTICE = "exam practice"
}

export const bimbelLPEventNames = {
  pageVisited: "Bimbel LP Visited",
  leadPhoneNumberEntered: "Bimbel LP mobile number entered ",
  leadNameEntered: "Bimbel LP name entered",
  leadGradeEntered: "Bimbel LP grade entered",
  leadSubmitButtonClicked: "Bimbel LP submit clicked",
  leadSuccessScreenViewed: "Bimbel LP success screen viewed",
  leadOkayButtonClickedOnSuccess:
    "Bimbel LP okay button clicked on success screen",
  leadWhatsappCTAClicked: "Bimbel LP WA button clicked"
};

export const bimbelUTBKPackageEventName = {
  pageVisited: "UTBK - Page visited",
  CTAClicked: "UTBK - CTA Button Header Clicked",
  stickyCTAClicked: "UTBK - CTA Sticky Button Clicked",
  topNavbarLinkClicked: "UTBK - Top bar navigation link clicked",
  hamburgerMenuLinkClicked: "UTBK - Hamburger menu link clicked",
  hamburgerMenuBannerClicked: "UTBK - Hamburger image link clicked",
  grade12VideoPageSquareCTAClicked:
    "UTBK - Square CTA Banner Clicked on Tanya Video Pages",
  grade12VideoPageRectangleCTAClicked:
    "UTBK - Rectangle CTA Banner Clicked on Tanya Video Pages",
  grade12VideoPageVideoBannerClosed: "UTBK - Closing Card on Video Player"
};
